// Modules
import React from 'react'

// Sections
import Message from './sections/message/Message'

// Components
import Page from 'components/layout/page/Page'

// Hooks
// import useLanguage from 'hooks/system/useLanguage'

// Styles
import './Landing.scss'

// View: Error > Landing
function Landing () {
	// Data
	// const { translate } = useLanguage('pages.error.views.landing')

	// Render
	return (
		<Page.View name="landing">
			<Message />
		</Page.View>
	)
}

// Export
export default Landing
